import { ADD_DASHBOARD_HOLDING_SUMMARY, DASHBOARD_HOLDING_START_LOADER, DASHBOARD_HOLDING_STOP_LOADER, DASHBOARD_HOLDING_ERROR, DASHBOARD_HOLDING_HIDE_ERROR, } from "@frameworks/web/redux/interfaces/Reports/iDashboardHoldingSummary";
const init = {
    data: [],
    summary: {
        date: "",
        message: "",
        totalInvestment: "",
        currentValue: "",
        totalPnL: "",
        daysPnL: "",
        totalPnLChange: "",
        daysPnLChange: "",
        totalPreviousClosingValue: "",
    },
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
    isOmneOnly: false,
    isBodEnabled: false,
    bodProcessInfoMessage: "",
};
const dashboardHoldingSummary = (state = init, actions) => {
    switch (actions.type) {
        case ADD_DASHBOARD_HOLDING_SUMMARY:
            return Object.assign(Object.assign({}, state), { data: actions.payload.data, summary: actions.payload.summary, isOmneOnly: actions.payload.isOmneOnly, isBodEnabled: actions.payload.isBodEnabled, bodProcessInfoMessage: actions.payload.bodProcessInfoMessage });
        case DASHBOARD_HOLDING_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case DASHBOARD_HOLDING_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        case DASHBOARD_HOLDING_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: actions.payload.errorData });
        case DASHBOARD_HOLDING_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: init.errorData });
        default:
            return Object.assign({}, state);
    }
};
export default dashboardHoldingSummary;
